import config from '@/config.js';
import {cookies} from "@/util";

export default {
    namespaced: true,

    state: () => ({
        authUser: null,
    }),

    getters: {
        user: (state) => state.authUser,
        loggedIn: () => {
            const token = cookies.get('chat_api_token');
            if (token) {
                window.http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                return true;
            }

            return false;
        },
        csrfInitiated: () => {
            return !!cookies.get('XSRF-TOKEN');
        },
    },

    mutations: {
        setCurrentUser(state, data) {
            state.authUser = data;
        },
    },

    actions: {
        async fetchCurrentUser({commit}) {
            try {
                const r = await window.http.get(`${config.API_URL}/current-user`);

                commit('setCurrentUser', r.data);

                return r;
            } catch (e) {
                //
            }
        },

        async getResetPasswordLink({state}, email = null) {
            if (!email) {
                email = state.authUser ? state.authUser.email : null;
            }

            if (!email) {
                return {success: false};
            }

            return await window.http.post(`${config.API_URL}/reset-password-link`, {email});
        },

        async resetPassword({}, {email, password, password_confirmation, token, is_new_account}) {
            return await window.http.post(`${config.API_URL}/reset-password`, {email, password, password_confirmation, token});
        },

        async checkActivationCode({}, activation) {
            return await window.http.post(`${config.API_URL}/check-activation`, {activation});
        },

        async login({}, {email, password, remember}) {
            const r = await window.http.post(`${config.API_URL}/login`, {email, password, remember});

            if (r.success) {
                window.http.defaults.headers.common['Authorization'] = `Bearer ${r.data.token}`;
                cookies.set('chat_api_token', r.data.token, 1);
            }

            return r;
        },

        async register({}, data) {
            return await window.http.post(`${config.API_URL}/register`, data);
        },

        async csrf() {
            await window.http.get(`${config.API_URL}/csrf-cookie`);
            window.http.defaults.headers.common['X-XSRF-TOKEN'] = decodeURI(cookies.get('XSRF-TOKEN'));
        },

        /**
         * @todo
         */
        async logout({commit}) {
            await window.http.post(`${config.API_URL}/logout`);

            cookies.set('chat_api_token', null);
            cookies.set('XSRF-TOKEN', null);
            cookies.set('laravel_session', null);
        }
    }
};
